const TostActionTypes = {
  SET_TOAST: 'TOAST_SHOW'
};

export default TostActionTypes;